const React = require('react')
const { Col } = require('reactstrap')
const { Phone, Mail, MapPin } = require('react-feather')

const FooterContactUsColumn = () => {
    return (
        <Col className='footer-section'>
            <h5 className='footer-title'>Contact Us</h5>
            <div className='footer-contact'>
                <div className='contact-item'>
                    <Phone size={16} />
                    (+84) 28 6271 7798
                </div>
                <div className='contact-item'>
                    <Mail size={16} />
                    contact@vietnamblockchain.asia
                </div>
                <div className='contact-item'>
                    <MapPin size={16} />
                    28/3 Lu Gia, Ward 15, District 11, Ho Chi Minh City
                </div>
            </div>
        </Col>
    )
}

module.exports = { FooterContactUsColumn }
